import { ConcreteEncodable } from "./ConcreteEncodable";

import { AdminModelUpdateImplEncoder } from "../../encoder/AdminModelUpdateImplEncoder";

import * as CubiqTS from "../../index";
import { AdminModelUpdate } from "../AdminModelUpdate";

export class AdminModelUpdateImpl extends ConcreteEncodable implements AdminModelUpdate {
  public static enType: string = "com.bcdfx.model.event.admin.AdminModelUpdateImpl";

  /*FID=1*/
  public entityType: string;
  /*FID=2*/
  public jsonPayLoad: string;
  /*FID=3*/
  public eventType: CubiqTS.ModelUpdateType;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AdminModelUpdateImplEncoder.Instance;
    this.setEncodableType(AdminModelUpdateImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AdminModelUpdateImpl[" +
      "entityType=" +
      this.entityType +
      "jsonPayLoad=" +
      this.jsonPayLoad +
      "eventType=" +
      this.eventType +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
